// permission
export const ADD_PERMISSION = 'ADD_PERMISSION';
export const GET_PERMISSION = 'GET_PERMISSION';
export const GET_PERMISSION_SUCCEED = 'GET_PERMISSION_SUCCEED';
export const GET_PERMISSION_FAIL = 'GET_PERMISSION_FAIL';
export const PUT_PERMISSION = 'PUT_PERMISSION';
export const PUT_PERMISSION_SUCCEED = 'PUT_PERMISSION_SUCCEED';
export const PUT_PERMISSION_FAIL = 'PUT_PERMISSION_FAIL';
export const DELETE_PERMISSION = 'DELETE_PERMISSION';

export const ADD_ROLE = 'ADD_ROLE';

// role
export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCEED = 'GET_ROLES_SUCCEED';
export const GET_ROLES_FAIL = 'GET_ROLES_FAIL';
export const DELETE_ROLE = 'DELETE_ROLE';

// action
export const POST_ACTION = 'POST_ACTION';
export const GET_ACTION = 'GET_ACTION';
export const GET_ACTION_SUCCEED = 'GET_ACTION_SUCCEED';
export const GET_ACTION_FAIL = 'GET_ACTION_FAIL';
export const DELETE_ACTION = 'DELETE_ACTION';

// action
export const GET_ROLE_INFO_BY_ID = 'GET_ROLE_INFO_BY_ID';

export const POST_PERMISSION_CONTROL_FOR_ROLE = 'POST_PERMISSION_CONTROL_FOR_ROLE';

// users
